<template>
    <div class="home" :class="{ 'auto-padding': noSubMenu }">
        <website-menu v-if="!isEmbed" :fixed="noSubMenu"></website-menu>
        <slot></slot>
        <website-footer v-if="!isEmbed"></website-footer>
    </div>
</template>

<script>
    import WebsiteFooter from "@/layout/website-footer.vue";
    import WebsiteMenu from "@/layout/website-menu.vue";
    export default {
        name: `website-page`,
        components: {WebsiteFooter, WebsiteMenu},
        props: {
            autoPadding: {type: Boolean, default: true},
            noSubMenu: {type: Boolean, default: false},
            loading: {type: Boolean, default: false}
        },
        computed: {
            isEmbed() {
                return this.$route.query.embed !== undefined;
            }
        }
    }
</script>

<style lang="scss" scoped>
.home {
    width: 100%;

    &.auto-padding {
        padding-top: 84px;

        @media (max-width: 576px) {
            padding-top: 79px;
        }
    }

}

.jumbotron {
    //background: url('../assets/img/backgrounds/mall.jpg') no-repeat center;
}
</style>
